var map = {
	"./academy.jpg": "241b",
	"./hngrow.jpg": "348d",
	"./intensives.jpg": "0c82",
	"./network.jpg": "ebaa",
	"./trainings.jpg": "dd99",
	"./webinars.jpg": "1c61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99b3";